module.exports = __webpack_public_path__ + "static/media/bebe.295fa78.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bebe.mp4
// module id = 41
// module chunks = 0